import { useState } from 'react'
import Layout from './Layout'
import api from '../services/api'

export default function MeuPerfil() {
  const usuario = JSON.parse(localStorage.getItem('pg_usuario') || '{}')
  const senhaProvisoria = localStorage.getItem('pg_trocar_senha') === 'true'

  const [form, setForm] = useState({ nome: usuario.nome || '', telefone: usuario.telefone || '' })
  const [senhaForm, setSenhaForm] = useState({ senha_atual: '', nova_senha: '', confirmar: '' })
  const [erro, setErro] = useState('')
  const [erroSenha, setErroSenha] = useState('')
  const [sucesso, setSucesso] = useState('')
  const [sucessoSenha, setSucessoSenha] = useState('')

  async function salvarDados() {
    if (!form.nome) { setErro('Nome é obrigatório'); return }
    setErro('')
    try {
      await api.put('/usuarios/perfil/meus-dados', form)
      const u = { ...usuario, nome: form.nome }
      localStorage.setItem('pg_usuario', JSON.stringify(u))
      setSucesso('Dados atualizados!')
      setTimeout(() => setSucesso(''), 3000)
    } catch(e) { setErro(e.response?.data?.erro || 'Erro ao salvar') }
  }

  async function alterarSenha() {
    setErroSenha('')
    if (!senhaForm.senha_atual) { setErroSenha('Informe a senha atual'); return }
    if (!senhaForm.nova_senha || senhaForm.nova_senha.length < 6) { setErroSenha('A nova senha deve ter pelo menos 6 caracteres'); return }
    if (senhaForm.nova_senha !== senhaForm.confirmar) { setErroSenha('As senhas não conferem'); return }
    try {
      await api.put('/usuarios/perfil/alterar-senha', { senha_atual: senhaForm.senha_atual, nova_senha: senhaForm.nova_senha })
      setSucessoSenha('Senha alterada com sucesso!')
      setSenhaForm({ senha_atual: '', nova_senha: '', confirmar: '' })
      localStorage.removeItem('pg_trocar_senha')
      setTimeout(() => setSucessoSenha(''), 3000)
    } catch(e) { setErroSenha(e.response?.data?.erro || 'Erro ao alterar senha') }
  }

  const inp = (val, onChange, placeholder, tipo='text') => (
    <input type={tipo} value={val} onChange={onChange} placeholder={placeholder}
      style={{ width:'100%', padding:'9px 11px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, boxSizing:'border-box' }} />
  )

  return (
    <Layout>
      <h1 style={{ fontSize:18, fontWeight:500, margin:'0 0 24px' }}>Meu perfil</h1>

      {senhaProvisoria && (
        <div style={{ background:'#fef9c3', border:'1px solid #fef08a', borderRadius:12, padding:20, marginBottom:24 }}>
          <div style={{ fontSize:15, fontWeight:600, color:'#854d0e', marginBottom:6 }}>🔑 Você está usando uma senha provisória</div>
          <div style={{ fontSize:13, color:'#374151', lineHeight:1.6 }}>
            Por segurança, altere sua senha antes de continuar usando o sistema.
          </div>
        </div>
      )}

      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:20, maxWidth:800 }}>
        <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:24 }}>
          <div style={{ fontSize:14, fontWeight:500, marginBottom:4 }}>Dados pessoais</div>
          <div style={{ fontSize:12, color:'#9ca3af', marginBottom:20 }}>O e-mail não pode ser alterado.</div>
          <div style={{ marginBottom:14 }}>
            <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:5, color:'#374151' }}>Nome completo *</label>
            {inp(form.nome, e => setForm(f => ({...f, nome:e.target.value})), 'Seu nome')}
          </div>
          <div style={{ marginBottom:14 }}>
            <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:5, color:'#374151' }}>E-mail</label>
            <input value={usuario.email || ''} disabled
              style={{ width:'100%', padding:'9px 11px', border:'1px solid #e5e7eb', borderRadius:8, fontSize:13, boxSizing:'border-box', background:'#f9fafb', color:'#9ca3af' }} />
          </div>
          <div style={{ marginBottom:20 }}>
            <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:5, color:'#374151' }}>Telefone</label>
            {inp(form.telefone, e => setForm(f => ({...f, telefone:e.target.value})), '(00) 00000-0000', 'tel')}
          </div>
          {erro && <div style={{ background:'#fef2f2', border:'1px solid #fecaca', borderRadius:8, padding:10, fontSize:12, color:'#dc2626', marginBottom:12 }}>{erro}</div>}
          {sucesso && <div style={{ background:'#f0fdf4', border:'1px solid #bbf7d0', borderRadius:8, padding:10, fontSize:12, color:'#15803d', marginBottom:12 }}>{sucesso}</div>}
          <button onClick={salvarDados}
            style={{ width:'100%', padding:10, background:'#185FA5', color:'white', border:'none', borderRadius:8, fontSize:13, cursor:'pointer', fontWeight:500 }}>
            Salvar dados
          </button>
        </div>

        <div style={{ background:'white', borderRadius:12, border:`1px solid ${senhaProvisoria ? '#fef08a' : '#e5e7eb'}`, padding:24 }}>
          <div style={{ fontSize:14, fontWeight:500, marginBottom:4 }}>
            {senhaProvisoria ? '🔑 Alterar senha provisória' : 'Alterar senha'}
          </div>
          <div style={{ fontSize:12, color:'#9ca3af', marginBottom:20 }}>Mínimo de 6 caracteres.</div>
          <div style={{ marginBottom:14 }}>
            <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:5, color:'#374151' }}>Senha atual *</label>
            {inp(senhaForm.senha_atual, e => setSenhaForm(f => ({...f, senha_atual:e.target.value})), '••••••••', 'password')}
          </div>
          <div style={{ marginBottom:14 }}>
            <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:5, color:'#374151' }}>Nova senha *</label>
            {inp(senhaForm.nova_senha, e => setSenhaForm(f => ({...f, nova_senha:e.target.value})), '••••••••', 'password')}
          </div>
          <div style={{ marginBottom:20 }}>
            <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:5, color:'#374151' }}>Confirmar nova senha *</label>
            {inp(senhaForm.confirmar, e => setSenhaForm(f => ({...f, confirmar:e.target.value})), '••••••••', 'password')}
          </div>
          {erroSenha && <div style={{ background:'#fef2f2', border:'1px solid #fecaca', borderRadius:8, padding:10, fontSize:12, color:'#dc2626', marginBottom:12 }}>{erroSenha}</div>}
          {sucessoSenha && <div style={{ background:'#f0fdf4', border:'1px solid #bbf7d0', borderRadius:8, padding:10, fontSize:12, color:'#15803d', marginBottom:12 }}>{sucessoSenha}</div>}
          <button onClick={alterarSenha}
            style={{ width:'100%', padding:10, background: senhaProvisoria ? '#854d0e' : '#185FA5', color:'white', border:'none', borderRadius:8, fontSize:13, cursor:'pointer', fontWeight:500 }}>
            Alterar senha
          </button>
        </div>
      </div>
    </Layout>
  )
}
